'use client';

import { useState } from 'react';
import { clearAllStorageAndCachesSilent } from '../lib/utils/storage-utils';
import { Button } from './core/button';
import { ResponsiveDrawerDialog } from './core/responsive-drawer-dialog';
import { MagicIcon, SuccessIcon } from './icons/BusinessIcons';

export function CheckForUpdatesDialog() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await clearAllStorageAndCachesSilent();
      // The function will reload the page, so we don't need to handle completion
    } catch (error) {
      console.error('Error clearing storage:', error);
      // Still reload on error to ensure fresh state
      window.location.reload();
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <ResponsiveDrawerDialog
      open={isOpen}
      onOpenChange={setIsOpen}
      trigger={
        <div className="relative flex cursor-pointer text-slate-800 min-w-[140px] select-none items-center rounded-sm px-2 py-2 pr-3 text-sm outline-none hover:bg-slate-50/80 transition duration-200 ease-in-out data-[highlighted]:bg-slate-200 focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50">
          <div className="flex w-full items-center">
            <MagicIcon className="mr-2 !h-4 !w-4" />
            Check for Updates
          </div>
        </div>
      }
      footer={
        <>
          <Button variant="outline" onClick={handleCancel} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="PositiveAction"
            onClick={handleConfirm}
            data-primary="true"
            isLoading={isLoading}
            disabled={isLoading}
          >
            Let&apos;s do it!
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        <div className="space-y-2">
          <h2 className="text-lg font-bold leading-none tracking-tight">
            Limited Connection?
          </h2>
          <p className="text-sm text-muted-foreground">
            Hard Refresh your page &amp; check for updates
          </p>
        </div>

        <div className="space-y-1">
          <p className="text-sm text-slate-600">This will:</p>
          <ul className="text-sm text-slate-600 space-y-2">
            <li className="flex items-center">
              <SuccessIcon className="mr-2 h-2.5 w-2.5" />
              Check for the latest version of Petboost
            </li>
            <li className="flex items-center">
              <SuccessIcon className="mr-2 h-2.5 w-2.5" />
              Refresh your page
            </li>
          </ul>
        </div>
      </div>
    </ResponsiveDrawerDialog>
  );
}
